
// chalit chart
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function Chart() {
//   const canvasRef = useRef(null);
//   const [houses, setHouses] = useState({});
//   const [ascSign, setAscSign] = useState(null); // store ascendant sign (1=Aries, 2=Taurus...12=Pisces)

//   // Fixed coordinates (North Indian style) → these are "slots" where houses can appear
//   // IMPORTANT: These coordinates never change — we only rotate which house goes where
//   const houseSlots = {
//     1: [ [10, 50], [30, 80], [30, 110] ],     // Top-left slot
//     2: [ [110, 220], [160, 200], [110, 240] ],// Bottom-left slot
//     3: [ [340, 300], [310, 300], [340, 280] ],// Bottom slot
//     4: [ [320, 90], [330, 110], [350,140],[370,120]],             // Top-right slot
//     5: [ [190, 230], [190, 250] ],            // Middle bottom slot
//     6: [ [290, 360], [290, 320], [290, 340] ],// Bottom-right slot
//     7: [ [20, 290], [60, 300] ],              // Left-middle slot
//     8: [ [90, 330], [110, 330],[50, 330] ],             // Left-bottom slot
//     9: [ [240, 200], [210, 210], [180, 220] ],// Middle-right slot
//     10:[ [290, 50], [290, 70] ],              // Right-top slot
//     11:[ [200, 90], [200, 120], [180, 170] ], // Middle-top slot
//     12:[ [80, 50], [80, 30], [80, 80] ]       // Left-top slot
//   };

//   // Fetch kundali data from API
//   useEffect(() => {
//     axios.get("https://core-c343.onrender.com/api/chalit-table", {
//       params: {
//         year: 2004,
//         month: 3,
//         day: 16,
//         hour: 5,
//         minute: 0,
//         location: "Kolkata",
//         timezone: "Asia/Kolkata"
//       }
//     })
//       .then((res) => {
//         // Save houses
//         setHouses(res.data.chalitTable.houses || {});
//         // Extract ascendant sign (1=Aries, 2=Taurus ... 12=Pisces)
//         // API usually gives ascendant degree like 345° → convert to zodiac sign
//         const ascDegree = parseFloat(res.data.chalitTable.ascendant);
//         const signNum = Math.floor(ascDegree / 30) + 1; // 0–29° = Aries, 30–59° = Taurus, etc.
//         setAscSign(signNum);
//       })
//       .catch((err) => {
//         console.error("Error fetching kundali data:", err);
//       });
//   }, []);

//   // Helper → rotate house numbers based on ascendant
//   // Example: if ascSign=4 (Cancer), then house 1 slot = Cancer, house 2 slot = Leo, etc.
//   const getRotatedHouseNumber = (slot) => {
//     if (!ascSign) return slot; // fallback
//     return ((ascSign - 1 + slot - 1) % 12) + 1;
//     // Explanation:
//     // ascSign-1 → shift base to 0
//     // slot-1    → slot index (0–11)
//     // %12       → wrap around zodiac circle
//     // +1        → convert back to 1–12 numbering
//   };

//   // Draw chart whenever houses update
//   useEffect(() => {
//     if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     // Clear canvas
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Draw outer diamond (North Indian style)
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#FF8C42";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Draw cross lines
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Draw planets and house numbers
//     Object.keys(houseSlots).forEach((slot) => {
//       const realHouseNum = getRotatedHouseNumber(parseInt(slot)); 
//       const items = houses[realHouseNum] || [];
//       const positions = houseSlots[slot];

//       // Draw each planet/house item
//       items.forEach((item, idx) => {
//         const pos = positions[idx] || positions[0];
//         if (!pos) return;

//         ctx.fillStyle = item.color || "black";
//         ctx.font = "bold 14px Arial";
//         ctx.fillText(`${item.name}(${realHouseNum})`, pos[0], pos[1]);
//       });

//       // Draw the house number inside the slot (just once)
//       // const numPos = positions[positions.length - 1]; 
//       // ctx.fillStyle = "blue";
//       // ctx.font = "12px Arial";
//       // ctx.fillText(realHouseNum.toString(), numPos[0], numPos[1] + 20);
//     });

//   }, [houses, ascSign]);

//   // Download as PNG
//   const downloadImage = () => {
//     const canvas = canvasRef.current;
//     const link = document.createElement("a");
//     link.download = "kundali.png";
//     link.href = canvas.toDataURL("image/png");
//     link.click();
//   };

//   // Copy to clipboard
//   const copyImage = async () => {
//     const canvas = canvasRef.current;
//     canvas.toBlob((blob) => {
//       const item = new ClipboardItem({ "image/png": blob });
//       navigator.clipboard.write([item]);
//     });
//   };

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <canvas
//         className="canvas"
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//       <div className="button-group" style={{ marginTop: "10px" }}>
//         <button onClick={downloadImage}>Download PNG</button>
//         <button onClick={copyImage} style={{ marginLeft: "10px" }}>
//           Copy Image
//         </button>
//       </div>
//     </div>
//   );
// }



// prasthara chart- one chart (the sun one)
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function Chart() {
//   const canvasRef = useRef(null);
//   const [bindus, setBindus] = useState([]);
//   const [chartMeta, setChartMeta] = useState({});
//   const [ascSign, setAscSign] = useState(1); // fallback Asc = Aries

//   // Coordinates of houses inside diamond (approx placement)
//   const houseSlots = {
//     1: [100, 350],  // "2" orange
//     2: [310, 360],  // bottom "3" gray
//     3: [360, 300],  // bottom "2" gray
//     4: [370, 90],   // top green "4"
//     5: [300, 40],   // top orange "2"
//     6: [90, 30],    // top gray "3"
//     7: [40, 100],   // top-left blue "2"
//     8: [30, 310],   // bottom-left green "3"
//     9: [150, 200],  // left inside orange "1"
//     10: [200, 270], // lower inside gray "4"
//     11: [270, 200], // right inside blue "1"
//     12: [200, 130], // upper inside blue "5"
//   };

//   // Fetch Prasthara data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/prasthara", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//         },
//       })
//       .then((res) => {
//         // use SUN reference planet
//         const data = res.data.prastharashtakavarga[0];
//         setChartMeta(data.chartMeta);

//         // "Total" row contains final bindus for 12 signs
//         const totalBindus = data.grid.find((g) => g.planet === "Total").bindus;
//         setBindus(totalBindus);

//         // Ascendant is not in prasthara API, so default Aries = 1
//         setAscSign(1);
//       })
//       .catch((err) => {
//         console.error("Error fetching prasthara data:", err);
//       });
//   }, []);

//   // Rotate houses based on ascendant sign
//   const getRotatedSign = (houseIdx) => {
//     if (!ascSign) return houseIdx;
//     return ((ascSign - 1 + (houseIdx - 1)) % 12) + 1;
//   };

//   // Color mapping by auspiciousness
//   const getDotColor = (signNum) => {
//     const signMap = {
//       1: "Aries",
//       2: "Taurus",
//       3: "Gemini",
//       4: "Cancer",
//       5: "Leo",
//       6: "Virgo",
//       7: "Libra",
//       8: "Scorpio",
//       9: "Sagittarius",
//       10: "Capricorn",
//       11: "Aquarius",
//       12: "Pisces",
//     };
//     const signName = signMap[signNum];

//     if (chartMeta.auspicious?.includes(signName)) return "orange";
//     if (chartMeta.inauspicious?.includes(signName)) return "dodgerblue";
//     if (chartMeta.mixed?.includes(signName)) return "seagreen";
//     return "grey";
//   };

//   // Draw chart
//   useEffect(() => {
//     if (!canvasRef.current || bindus.length === 0) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Outer diamond
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#FF8C42";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Cross diagonals
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Draw bindus as circles
//     Object.keys(houseSlots).forEach((houseIdx) => {
//       const realSign = getRotatedSign(parseInt(houseIdx));
//       const binduValue = bindus[realSign - 1]; // pick bindu for this sign
//       const [x, y] = houseSlots[houseIdx];

//       // Circle
//       ctx.beginPath();
//       ctx.arc(x, y, 20, 0, 2 * Math.PI);
//       ctx.fillStyle = getDotColor(realSign);
//       ctx.fill();

//       // Number inside circle
//       ctx.fillStyle = "white";
//       ctx.font = "bold 14px Arial";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "middle";
//       ctx.fillText(binduValue, x, y);

//       // Draw house numbers (1–12)
//       ctx.fillStyle = "black";
//       ctx.font = "12px Arial";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "top";
//       const rotatedHouseNum = getRotatedSign(parseInt(houseIdx));
//       ctx.fillText(rotatedHouseNum, x, y + 25); // below each circle


//     });
//   }, [bindus, chartMeta, ascSign]);

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <canvas
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//     </div>
//   );
// }


// prasthara chart - all charts rendered (final version)
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function Chart() {
//   const [prastharas, setPrastharas] = useState([]);   // all planets
//   const [ascSign, setAscSign] = useState(1); // fallback Asc = Aries

//   // Coordinates of houses inside diamond
//   const houseSlots = {
//     1: [100, 350],
//     2: [310, 360],
//     3: [360, 300],
//     4: [370, 90],
//     5: [300, 40],
//     6: [90, 30],
//     7: [40, 100],
//     8: [30, 310],
//     9: [150, 200],
//     10: [200, 270],
//     11: [270, 200],
//     12: [200, 130],
//   };

//   // Fetch Prasthara data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/prasthara", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//         },
//       })
//       .then((res) => {
//         const allData = res.data.prastharashtakavarga;
//         setPrastharas(allData);
//         setAscSign(1); // default Aries = Asc
//       })
//       .catch((err) => {
//         console.error("Error fetching prasthara data:", err);
//       });
//   }, []);

//   // Rotate houses based on ascendant sign
//   const getRotatedSign = (houseIdx) => {
//     if (!ascSign) return houseIdx;
//     return ((ascSign - 1 + (houseIdx - 1)) % 12) + 1;
//   };

//   // Color mapping by auspiciousness
//   const getDotColor = (signNum, chartMeta) => {
//     const signMap = {
//       1: "Aries",
//       2: "Taurus",
//       3: "Gemini",
//       4: "Cancer",
//       5: "Leo",
//       6: "Virgo",
//       7: "Libra",
//       8: "Scorpio",
//       9: "Sagittarius",
//       10: "Capricorn",
//       11: "Aquarius",
//       12: "Pisces",
//     };
//     const signName = signMap[signNum];

//     if (chartMeta?.auspicious?.includes(signName)) return "orange";
//     if (chartMeta?.inauspicious?.includes(signName)) return "dodgerblue";
//     if (chartMeta?.mixed?.includes(signName)) return "seagreen";
//     return "grey";
//   };

//   // Component for each canvas chart
//   const ChartCanvas = ({ data }) => {
//     const canvasRef = useRef(null);

//     useEffect(() => {
//       if (!canvasRef.current || !data) return;

//       const bindus = data.grid.find((g) => g.planet === "Total").bindus;
//       const chartMeta = data.chartMeta;

//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext("2d");

//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Outer diamond
//       ctx.beginPath();
//       ctx.moveTo(200, 0);
//       ctx.lineTo(400, 200);
//       ctx.lineTo(200, 400);
//       ctx.lineTo(0, 200);
//       ctx.closePath();
//       ctx.strokeStyle = "#FF8C42";
//       ctx.lineWidth = 2;
//       ctx.stroke();

//       // Cross diagonals
//       ctx.beginPath();
//       ctx.moveTo(0, 0);
//       ctx.lineTo(400, 400);
//       ctx.moveTo(400, 0);
//       ctx.lineTo(0, 400);
//       ctx.stroke();

//       // Draw bindus
//       Object.keys(houseSlots).forEach((houseIdx) => {
//         const realSign = getRotatedSign(parseInt(houseIdx));
//         const binduValue = bindus[realSign - 1];
//         const [x, y] = houseSlots[houseIdx];

//         // Circle
//         ctx.beginPath();
//         ctx.arc(x, y, 20, 0, 2 * Math.PI);
//         ctx.fillStyle = getDotColor(realSign, chartMeta);
//         ctx.fill();

//         // Number inside circle
//         ctx.fillStyle = "white";
//         ctx.font = "bold 14px Arial";
//         ctx.textAlign = "center";
//         ctx.textBaseline = "middle";
//         ctx.fillText(binduValue, x, y);

//         // House number
//         ctx.fillStyle = "black";
//         ctx.font = "12px Arial";
//         ctx.textAlign = "center";
//         ctx.textBaseline = "top";
//         const rotatedHouseNum = getRotatedSign(parseInt(houseIdx));
//         ctx.fillText(rotatedHouseNum, x, y + 25);
//       });
//     }, [data]);

//     return (
//       <div style={{ marginBottom: "30px", textAlign: "center" }}>
//         <h4>{data.planet}</h4>
//         <canvas
//           ref={canvasRef}
//           width={400}
//           height={400}
//           style={{ border: "1px solid black" }}
//         ></canvas>
//       </div>
//     );
//   };

//   return (
//     <div className="kundali-container">
//       {prastharas.map((p, idx) => (
//         <ChartCanvas key={idx} data={p} />
//       ))}
//     </div>
//   );
// }



// Ashtak chart
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function Chart() {
//   const canvasRef = useRef(null);
//   const [bindus, setBindus] = useState([]);
//   const [ascSign, setAscSign] = useState(1); // fallback Asc = Aries

//   // Coordinates of houses inside diamond
//   const houseSlots = {
//     1: [100, 350],
//     2: [310, 360],
//     3: [360, 300],
//     4: [370, 90],
//     5: [300, 40],
//     6: [90, 30],
//     7: [40, 100],
//     8: [30, 310],
//     9: [150, 200],
//     10: [200, 270],
//     11: [270, 200],
//     12: [200, 130],
//   };

//   // Fetch Sarvashtakavarga data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/sarvashtakavarga", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//         },
//       })
//       .then((res) => {
//         const data = res.data.sarvashtakavarga;
//         const totalBindus = data.grid.find((g) => g.planet === "Total").bindus;
//         setBindus(totalBindus);

//         // Default Ascendant = Aries (later replace with actual Asc)
//         setAscSign(1);
//       })
//       .catch((err) => {
//         console.error("Error fetching sarvashtakavarga data:", err);
//       });
//   }, []);

//   // Rotate houses based on ascendant sign
//   const getRotatedSign = (houseIdx) => {
//     if (!ascSign) return houseIdx;
//     return ((ascSign - 1 + (houseIdx - 1)) % 12) + 1;
//   };

//   // Color mapping based on bindu value (custom logic since no chartMeta)
//   const getDotColor = (binduValue) => {
//     if (binduValue >= 4) return "orange";      // strong/auspicious
//     if (binduValue === 3) return "seagreen";   // medium
//     if (binduValue === 2) return "dodgerblue"; // weaker
//     return "grey";                             // low
//   };

//   // Draw chart
//   useEffect(() => {
//     if (!canvasRef.current || bindus.length === 0) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Outer diamond
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#FF8C42";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Cross diagonals
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Draw bindus as circles
//     Object.keys(houseSlots).forEach((houseIdx) => {
//       const realSign = getRotatedSign(parseInt(houseIdx));
//       const binduValue = bindus[realSign - 1]; // pick bindu for this sign
//       const [x, y] = houseSlots[houseIdx];

//       // Circle
//       ctx.beginPath();
//       ctx.arc(x, y, 20, 0, 2 * Math.PI);
//       ctx.fillStyle = getDotColor(binduValue);
//       ctx.fill();

//       // Number inside circle
//       ctx.fillStyle = "white";
//       ctx.font = "bold 14px Arial";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "middle";
//       ctx.fillText(binduValue, x, y);

//       // House number label
//       ctx.fillStyle = "black";
//       ctx.font = "12px Arial";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "top";
//       const rotatedHouseNum = getRotatedSign(parseInt(houseIdx));
//       ctx.fillText(rotatedHouseNum, x, y + 25);
//     });
//   }, [bindus, ascSign]);

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <canvas
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//     </div>
//   );
// }




// navamsha chart
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function NavamsaChart() {
//   const canvasRef = useRef(null);
//   const [navamsa, setNavamsa] = useState({});
//   const [ascSign, setAscSign] = useState(null);

//   // North Indian chart slots
//   const houseSlots = {
//     1: [[10, 50], [30, 80], [30, 110]],     
//     2: [[110, 220], [160, 200], [110, 240]],
//     3: [[340, 300], [310, 300], [340, 280]],
//     4: [[320, 110], [340, 110], [360, 140], [370, 120]],
//     5: [[190, 230], [190, 250]],
//     6: [[290, 360], [290, 320], [290, 340]],
//     7: [[20, 290], [60, 300]],
//     8: [[90, 330], [110, 330], [50, 330]],
//     9: [[240, 200], [210, 210], [180, 220]],
//     10: [[290, 50], [290, 70]],
//     11: [[200, 90], [200, 120], [180, 170]],
//     12: [[80, 50], [80, 30], [80, 80]],
//   };

//   // Fetch navamsa data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/navamsa", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//           timezone: "Asia/Kolkata",
//         },
//       })
//       .then((res) => {
//         const data = res.data;
//         const positions = data.navamsaPositions;

//         // Convert navamsaPositions → house structure
//         // Example: if Sun is in Cancer → house 4 (Cancer = 4th sign)
//         const houses = {};
//         Object.keys(positions).forEach((planet) => {
//           const { sign, signIndex, degree } = positions[planet];
//           if (!houses[signIndex + 1]) houses[signIndex + 1] = [];
//           houses[signIndex + 1].push({
//             name: planet,
//             degree,
//           });
//         });

//         setNavamsa(houses);

//         // Ascendant for navamsa = signIndex of D9 lagna
//         // If not given, derive manually (here we assume D9 lagna = Sun sign)
//         const asc = positions.sun?.signIndex + 1 || 1;
//         setAscSign(asc);
//       })
//       .catch((err) => {
//         console.error("Error fetching navamsa:", err);
//       });
//   }, []);

//   // Rotate chart houses
//   const getRotatedHouseNumber = (slot) => {
//     if (!ascSign) return slot;
//     return ((ascSign - 1 + slot - 1) % 12) + 1;
//   };

//   // Draw Navamsa chart
//   useEffect(() => {
//     if (!canvasRef.current || Object.keys(navamsa).length === 0 || !ascSign)
//       return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Draw outer diamond
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#e77d0bff";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Draw cross lines
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Draw planets
//     Object.keys(houseSlots).forEach((slot) => {
//       const realHouseNum = getRotatedHouseNumber(parseInt(slot));
//       const items = navamsa[realHouseNum] || [];
//       const positions = houseSlots[slot];

//       items.forEach((item, idx) => {
//         const pos = positions[idx] || positions[0];
//         ctx.fillStyle = "black";
//         ctx.font = "bold 13px Arial";
//         ctx.fillText(`${item.name}`, pos[0], pos[1]);
//       });
//       // Draw house number inside each slot
//       const numPos = positions[0]; // pick first coordinate of slot
//       ctx.fillStyle = "orange";
//       ctx.font = "12px Arial";
//       ctx.fillText(realHouseNum.toString(), numPos[0], numPos[1] - 10);
//     });
//   }, [navamsa, ascSign]);

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <h3>Navamsa (D9) Chart</h3>
//       <canvas
//         className="canvas"
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//     </div>
//   );
// }


//lagna chart
// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss"; // reuse same css

// export default function LagnaChart() {
//   const canvasRef = useRef(null);
//   const [houses, setHouses] = useState({});
//   const [ascSign, setAscSign] = useState(null);

//   // Slots (same North Indian style)
//   const houseSlots = {
//     1: [[10, 50], [30, 80], [30, 110]],     
//     2: [[110, 220], [160, 200], [110, 240]],
//     3: [[340, 300], [310, 300], [340, 280]],
//     4: [[320, 110], [340, 110], [360, 140], [370, 120]],
//     5: [[190, 230], [190, 250]],
//     6: [[290, 360], [290, 320], [290, 340]],
//     7: [[20, 290], [60, 300]],
//     8: [[90, 330], [110, 330], [50, 330]],
//     9: [[240, 200], [210, 210], [180, 220]],
//     10: [[290, 50], [290, 70]],
//     11: [[200, 90], [200, 120], [180, 170]],
//     12: [[80, 50], [80, 30], [80, 80]],
//   };

//   // Fetch Lagna data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/lagna-chart", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//           timezone: "Asia/Kolkata",
//         },
//       })
//       .then((res) => {
//         const data = res.data;

//         // API gives planetToHouseMap directly
//         const planetMap = data.planetToHouseMap;
//         const houseData = {};

//         Object.keys(planetMap).forEach((planet) => {
//           const houseNum = planetMap[planet];
//           if (!houseData[houseNum]) houseData[houseNum] = [];
//           houseData[houseNum].push({ name: planet });
//         });

//         setHouses(houseData);

//         // Ascendant = house 1 (we don’t need to rotate like Navamsa, API already gives it)
//         setAscSign(1);
//       })
//       .catch((err) => {
//         console.error("Error fetching lagna chart:", err);
//       });
//   }, []);

//   // Draw chart
//   useEffect(() => {
//     if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign)
//       return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Outer diamond
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#e8811aff";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Cross lines
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Planets
//     Object.keys(houseSlots).forEach((slot) => {
//       const items = houses[slot] || [];
//       const positions = houseSlots[slot];

//       items.forEach((item, idx) => {
//         const pos = positions[idx] || positions[0];
//         ctx.fillStyle = "black";
//         ctx.font = "bold 13px Arial";
//         ctx.fillText(item.name, pos[0], pos[1]);
//       });

//       // House number           
//       const numPos = positions[0];
//       ctx.fillStyle = "orange";
//       ctx.font = "12px Arial";
//       ctx.fillText(slot.toString(), numPos[0], numPos[1] - 10);
//     });
//   }, [houses, ascSign]);

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <h3>Lagna Chart</h3>
//       <canvas
//         className="canvas"
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//     </div>
//   );
// }


//d1 to d16 chart

// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";
// import "./Chart.scss";

// export default function AllChart() {
//   const canvasRef = useRef(null);
//   const [charts, setCharts] = useState({});
//   const [selectedChart, setSelectedChart] = useState("D1");

//   // House slots: first coordinate = house number, rest = planets
//   const houseSlots = {
//     1: [[10, 50], [30, 80], [30, 110]],
//     2: [[110, 220], [100, 200], [110, 240], [90, 260]],
//     3: [[340, 280], [310, 300], [340, 280]],
//     4: [[320, 110], [340, 110], [360, 140], [370, 120]],
//     5: [[190, 230], [190, 250], [190, 280]],
//     6: [[290, 360], [290, 320], [290, 340]],
//     7: [[20, 290], [40, 300]],
//     8: [[90, 330], [100, 350], [50, 330]],
//     9: [[240, 200], [270, 210], [250, 180]],
//     10: [[290, 50], [290, 70], [250, 30]],
//     11: [[200, 90], [200, 120], [180, 170]],
//     12: [[100, 50], [80, 30], [80, 80], [60, 60]],
//   };

//   // Fetch API data
//   useEffect(() => {
//     axios
//       .get("https://core-c343.onrender.com/api/varga", {
//         params: {
//           year: 2004,
//           month: 3,
//           day: 16,
//           hour: 5,
//           minute: 0,
//           location: "Kolkata",
//         },
//       })
//       .then((res) => {
//         setCharts(res.data.divisionalCharts || {});
//       })
//       .catch((err) => {
//         console.error("Error fetching divisional charts:", err);
//       });
//   }, []);

//   // Draw chart
//   useEffect(() => {
//     if (!canvasRef.current || !charts[selectedChart]) return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Outer diamond
//     ctx.beginPath();
//     ctx.moveTo(200, 0);
//     ctx.lineTo(400, 200);
//     ctx.lineTo(200, 400);
//     ctx.lineTo(0, 200);
//     ctx.closePath();
//     ctx.strokeStyle = "#e8811aff";
//     ctx.lineWidth = 2;
//     ctx.stroke();

//     // Cross lines
//     ctx.beginPath();
//     ctx.moveTo(0, 0);
//     ctx.lineTo(400, 400);
//     ctx.moveTo(400, 0);
//     ctx.lineTo(0, 400);
//     ctx.stroke();

//     // Current chart
//     const currentChart = charts[selectedChart];
//     const houseData = {};

//     Object.keys(currentChart).forEach((planet) => {
//       if (planet === "ASCENDANT") return; // skip Ascendant
//       const houseNum = currentChart[planet];
//       if (!houseData[houseNum]) houseData[houseNum] = [];
//       houseData[houseNum].push(planet);
//     });

//     // Draw houses
//     Object.keys(houseSlots).forEach((slot) => {
//       const positions = houseSlots[slot];
//       if (!positions || positions.length === 0) return;

//       // 1st position → House number
//       const numPos = positions[0];
//       ctx.fillStyle = "orange";
//       ctx.font = "12px Arial";
//       ctx.fillText(slot.toString(), numPos[0], numPos[1]);

//       // Remaining positions → Planets
//       const planetPositions = positions.slice(1);
//       const items = houseData[slot] || [];

//       items.forEach((planet, idx) => {
//         const pos =
//           planetPositions[idx] ||
//           [numPos[0] + 20 * (idx + 1), numPos[1] + 15]; // fallback offset

//         ctx.fillStyle = "black";
//         ctx.font = "bold 13px Arial";
//         ctx.fillText(planet, pos[0], pos[1]);
//       });
//     });
//   }, [charts, selectedChart]);

//   return (
//     <div className="kundali-container" style={{ textAlign: "center" }}>
//       <h3>D1 to D16 Charts</h3>

//       <select
//         value={selectedChart}
//         onChange={(e) => setSelectedChart(e.target.value)}
//         style={{ marginBottom: "10px", padding: "5px" }}
//       >
//         {Object.keys(charts).map((chartKey) => (
//           <option key={chartKey} value={chartKey}>
//             {chartKey}
//           </option>
//         ))}
//       </select>

//       <canvas
//         className="canvas"
//         ref={canvasRef}
//         width={400}
//         height={400}
//         style={{ border: "1px solid black" }}
//       ></canvas>
//     </div>
//   );
// }

//Transit Chart
import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./Chart.scss"; // reuse same css

export default function LagnaChart() {
  const canvasRef = useRef(null);
  const [houses, setHouses] = useState({});
  const [ascSign, setAscSign] = useState(null);

  // Slots = anchor points (just one per house is enough now)
  const houseSlots = {
    1: [10, 50],
    2: [110, 220],
    3: [340, 300],
    4: [320, 110],
    5: [190, 230],
    6: [290, 360],
    7: [20, 290],
    8: [90, 330],
    9: [240, 200],
    10: [290, 50],
    11: [200, 90],
    12: [80, 50],
  };

  // Fetch Transit data
  useEffect(() => {
    axios
      .get("https://core-c343.onrender.com/api/transit-chart", {
        params: {
          year: 2025,
          month: 9,
          day: 18,
          hour: 16,
          minute: 42,
          timezone: "Asia/Kolkata",
        },
      })
      .then((res) => {
        const data = res.data;
        const planetaryPositions = data.planetaryPositions;

        const houseData = {};

        Object.keys(planetaryPositions).forEach((planet) => {
          const { longitude } = planetaryPositions[planet];
          const houseNum = Math.floor(longitude / 30) + 1; // 1–12
          if (!houseData[houseNum]) houseData[houseNum] = [];
          houseData[houseNum].push({ name: planet });
        });

        setHouses(houseData);

        // Assume Ascendant = house 1
        setAscSign(1);
      })
      .catch((err) => {
        console.error("Error fetching transit chart:", err);
      });
  }, []);

  // Draw chart
  useEffect(() => {
    if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign)
      return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#e8811aff";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Planets + House numbers
    Object.keys(houseSlots).forEach((slot) => {
      const items = houses[slot] || [];
      const [baseX, baseY] = houseSlots[slot];

      // Draw planets with spacing
      items.forEach((item, idx) => {
        const offsetX = idx * 20; // spread horizontally
        const offsetY = idx * 15 + 15; // spread vertically
        ctx.fillStyle = "black";
        ctx.font = "bold 13px Arial";
        ctx.fillText(item.name, baseX + offsetX, baseY + offsetY);
      });

      // House number (just above the anchor point)
      ctx.fillStyle = "orange";
      ctx.font = "12px Arial";
      ctx.fillText(slot.toString(), baseX, baseY - 5);
    });
  }, [houses, ascSign]);

  return (
    <div className="kundali-container" style={{ textAlign: "center" }}>
      <h3>Transit Chart</h3>
      <canvas
        className="canvas"
        ref={canvasRef}
        width={400}
        height={400}
        style={{ border: "1px solid black" }}
      ></canvas>
    </div>
  );
}



